if (!customElements.get('cart-delivery-estimate')) {
  class CartDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.requestNumber = 0;
      this.calculateDelivery();

const drawerItems = this
  .closest('cart-drawer')
  ?.querySelector('.cart-item-list__body');

const cartPageItems = this
  .closest('.cart-form')
  ?.querySelector('.cart-item-list__body');

const cartItems = drawerItems || cartPageItems;

      if (cartItems) {
        this.cartObserver = new MutationObserver(() => {
          clearTimeout(this.updateTimer);

          this.updateTimer = setTimeout(() => {
            this.calculateDelivery();
          }, 500);
        });

        this.cartObserver.observe(cartItems, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true
        });
      }
    }

    disconnectedCallback() {
      this.cartObserver?.disconnect();
      clearTimeout(this.updateTimer);
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split('.');
      const whole = parts[0].replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ' '
      );

      return `R ${whole}.${parts[1]}`;
    }

    setLoading() {
      const priceElement = this.querySelector(
        '[data-delivery-price]'
      );

      const totalElement = this.querySelector(
        '[data-delivery-total]'
      );

      if (priceElement) {
        priceElement.textContent = 'Calculating…';
      }

      if (totalElement) {
        totalElement.textContent = 'Calculating…';
      }
    }

    setUnavailable() {
      const priceElement = this.querySelector(
        '[data-delivery-price]'
      );

      const totalElement = this.querySelector(
        '[data-delivery-total]'
      );

      if (priceElement) {
        priceElement.textContent = 'Calculated at checkout';
      }

      if (totalElement) {
        totalElement.textContent = 'Calculated at checkout';
      }
    }

    async calculateDelivery() {
      const currentRequest = ++this.requestNumber;
      this.setLoading();

      try {
        const root = window.Shopify?.routes?.root || '/';

        const address = new URLSearchParams({
          'shipping_address[country]': 'South Africa',
          'shipping_address[province]': 'Western Cape',
          'shipping_address[zip]': '8001'
        });

        const prepareResponse = await fetch(
          `${root}cart/prepare_shipping_rates.json?${address.toString()}`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!prepareResponse.ok) {
          throw new Error('Unable to prepare shipping rates');
        }

        let shippingRates = null;

        for (let attempt = 0; attempt < 10; attempt++) {
          await new Promise(resolve => setTimeout(resolve, 400));

          const rateResponse = await fetch(
            `${root}cart/async_shipping_rates.json?${address.toString()}`,
            {
              headers: {
                Accept: 'application/json'
              }
            }
          );

          if (!rateResponse.ok) continue;

          const rateData = await rateResponse.json();

          if (Array.isArray(rateData?.shipping_rates)) {
            shippingRates = rateData.shipping_rates;
            break;
          }
        }

        const cartResponse = await fetch(`${root}cart.js`, {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!cartResponse.ok) {
          throw new Error('Unable to retrieve cart');
        }

        const cart = await cartResponse.json();

        if (currentRequest !== this.requestNumber) return;

        if (!shippingRates?.length) {
          this.setUnavailable();
          return;
        }

        const deliveryRates = shippingRates.filter(rate => {
          const name = `${rate.name || ''} ${rate.title || ''}`;

          return !/(collection|collect|pickup|pick-up)/i.test(name);
        });

        const availableRates = deliveryRates.length
          ? deliveryRates
          : shippingRates;

        const selectedRate = availableRates
          .slice()
          .sort((first, second) => {
            return parseFloat(first.price) - parseFloat(second.price);
          })[0];

        const deliveryCents = Math.round(
          parseFloat(selectedRate.price) * 100
        );

        const subtotalElement = this.querySelector(
          '[data-delivery-subtotal]'
        );

        const priceElement = this.querySelector(
          '[data-delivery-price]'
        );

        const totalElement = this.querySelector(
          '[data-delivery-total]'
        );

        if (subtotalElement) {
          subtotalElement.textContent = this.formatMoney(
            cart.total_price
          );
        }

        if (priceElement) {
          priceElement.textContent =
            deliveryCents === 0
              ? 'FREE'
              : this.formatMoney(deliveryCents);
        }

        if (totalElement) {
          totalElement.textContent = this.formatMoney(
            cart.total_price + deliveryCents
          );
        }
      } catch (error) {
        console.error('Delivery estimate error:', error);

        if (currentRequest === this.requestNumber) {
          this.setUnavailable();
        }
      }
    }
  }

  customElements.define(
    'cart-delivery-estimate',
    CartDeliveryEstimate
  );
}